export default __webpack_public_path__ + "static/media/learning_laws.fe084d49.jpg";